import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericSelect } from '../../components';
import { InputModelWithSource, InputBaseModel } from '../../models';
import { InputWithSource } from '../../componentTypes';
import { InputIds } from '../../misc';
import { useAppStore } from '../../stores';

const DeductionTypeInput: InputWithSource = ({ input }) => {
    const { nodesStore } = useAppStore();

    // Filter options to exclude already-selected deduction types (except the current input's value)
    const node = nodesStore.getNodeByInputGuid(input.guid);

    let filteredOptions = input.sourceProvider.options;

    if (node) {
        const allDeductionTypeInputs = node
            .getInputsAtSameLevel(input.guid)
            .filter((i: InputBaseModel) => i.id.startsWith(InputIds.Deductions.DeductionType));

        const selectedValues = allDeductionTypeInputs
            .filter((i: InputBaseModel) => i.guid !== input.guid && i.value) // Exclude current input (by guid) and empty values
            .map((i: InputBaseModel) => i.value as string);

        filteredOptions = input.sourceProvider.options.filter(option => !selectedValues.includes(option.value));
    }

    return <GenericSelect label={input.name} input={input} options={filteredOptions} />;
};

DeductionTypeInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(DeductionTypeInput);
